import { URLExtraParams } from '../typings';

import Ajax from '../lib/ajax';
import appendURLParams from '../helpers/append-url-parameters';
import { liveValidatePattern } from '../validate/pattern';
import { liveValidateMaxLength } from '../validate/maxlength';
import { liveValidateMinLength } from '../validate/minlength';
import { liveValidateBlur } from '../validate/blur';
import { liveValidateRequired } from '../validate/required';
import { liveValidateSubmit, validateSubmit, autoFocusFirstOnSubmitError } from '../validate/submit';
import { setLoadingIndicator, removeLoadingIndicator } from '../forms/loading-indicator';
import appendScripts from '../lib/append-scripts';

export default function validateLoginForm(element: string): boolean {
    const form: HTMLFormElement | null = document.querySelector(element);

    if (form) {
        form.setAttribute('novalidate', 'novalidate');

        const inputs = [form.username, form.password];

        for (const el of inputs) {
            liveValidateMinLength(el);
            liveValidateMaxLength(el);
            liveValidatePattern(el);
            liveValidateBlur(el);
            liveValidateRequired(el);
        }

        liveValidateSubmit(form);

        form.addEventListener('submit', function (e: Event) {
            return onLoginSubmit(e, form, inputs);
        });
    }

    return false;
}

const onLoginSubmit = (e: Event, form: HTMLFormElement, inputs: any[]) => {
    const isModal = !!document.querySelector('.modal--login');
    const urlExtraParams: URLExtraParams = { partial: 1 };
    const extraHeaders = { 'CC-Redirect-Assist': 'yes' };
    const errors = [...validateSubmit(inputs)];
    const valid = errors.indexOf(false) === -1;

    if (!valid) {
        form.classList.add('focus-visible');
        autoFocusFirstOnSubmitError(form);

        e.preventDefault();

        return false;
    }

    if (!isModal) {
        return;
    }

    const action: string | null = form.getAttribute('action');

    setLoadingIndicator(form);

    if (!action) {
        return;
    }

    e.preventDefault();

    const url: string = appendURLParams(action, urlExtraParams);
    const data: FormData = new FormData(form);
    const request: Ajax = new Ajax();

    request
        .postFormData(url, data, extraHeaders)
        .then((response: Response) => {
            if (response.status === 205) {
                document.location.href = response.headers.get('location') as string;
                return;
            }

            removeLoadingIndicator(form);

            return response.text();
        })
        .then((body: string) => {
            const loginWrapper: HTMLDivElement | null = document.querySelector('.js-login-wrapper');
            if (body && loginWrapper) {
                loginWrapper.innerHTML = body;
                appendScripts(loginWrapper);
            }
        })
        .catch(() => {
            document.querySelector('.js-logon-error')?.classList.remove('hlp--hidden');
            removeLoadingIndicator(form);
        });

    return false;
};
